<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <template>
              <grid-centro :key="gridDocumento"></grid-centro>
            </template>
            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
              <v-btn
                :loading="loading"
                color="primary"
                dark
                class="mb-2"
                @click="downloadCenter()"
                >Descargar Centros</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import GridCentro from "@/modules/capacitacion/views/centros/GridCentro.vue";

export default {
  name: "centro",

  components: {
    GridCentro,
  },

  props: {
    tabSelected: "",
  },

  data() {
    return {
      loading: false,
      proveedor: {},
      //rowsTable: [20],
      tabs: ["Acuerdo", "Progreso", "Contingencia", "Calidad"],
      contratoId: "",
      tabSelect: "",
      activeTab: "",
      index: "",
      // rowsPerPageItems: [10],
      // pagination: {
      //   page: 1,
      //   rowsPerPage: 10,
      //   pages: 0,
      //   },
      //rowsPerPageItems: [20],
      // pagination: {
      //   rowsPerPage: 20
      // },
      filter: false,
      usuarioLogged: "",
      gridDocumento: 20,
      idEstado: "",
      tipeCenter: "",
      contratoId: "",
    };
  },

  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
    this.tipeCenter = this.$store.getters.subTabSelectedStored;
    this.contratoId = this.$store.getters.contratoStored;
  },
  created() {},

  methods: {
    reloadDocumento() {
      this.gridDocumento += 22;
    },

    selected(tab) {
      this.tabSelect = tab;
    },

    filterDoc() {
      this.filter = true;
    },

    downloadCenter() {
      let that = this;
      let filename = "Centros_" + this.tipeCenter + ".xls";
      axios({
        url: "/centro/download/" + this.tipeCenter + "/" + this.contratoId,
        method: "GET",
        responseType: "blob",
      })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
  },
};
</script>
